import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsHocHam } from '../../services/danhmuc';

const HocHamSelectBox = ({ value, disabled, onChange, allowClear }: { value?: number, disabled?: boolean, onChange: (e: any) => void, allowClear?: boolean }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsHocHam(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' , height: '35px' }}
            showSearch
            placeholder="--Chọn trình độ đào tạo--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            disabled={disabled}
            allowClear={allowClear}
        />
    );
};

export default HocHamSelectBox;
